<div class="loan">
  <div class="row middle-xs between-xs">
    <div class="col-no-gutter">
      <h4 class="loan__title">{{label}}</h4>
    </div>
    <ng-container *ngIf="!readonly">
      <div class="col-sm-3 col-no-gutter">
        <mfp-button
          class="loan__remove"
          color="secondary"
          [fill]="removeFill"
          [size]="removeSize"
          [icon]="removeIcon"
          [iconPosition]="removeIconPosition"
          [label]="removeLabel"
          (click)="remove()"
        ></mfp-button>
      </div>
    </ng-container>

  </div>
  <div [formGroup]="form">
    <div class="row row-xs--no-margin">
      <div class="col-xs-24 col-sm-6 col-gutter-lr">
        <mfp-select
          view="agent"
          [name]="loanTypeName"
          [formControlName]="loanTypeName"
          [label]="loanTypeLabel"
          [color]="loanTypeColor"
          [options]="loanTypeOptions"
          [placeholder]="loanTypePlaceholder"
          [required]="false"
          [readonly]="false"
          [success]="false"
          [error]="false"
          [success]="isFieldValid(form, loanTypeName)"
          [error]="isFieldInvalid(form, loanTypeName)"
          [helper]="getFieldError(form, loanTypeName) | translate"
          [readonly]="readonly"
          [required]="required"
        ></mfp-select>
      </div>
      <div class="col-xs-24 col-sm-9 col-gutter-lr">
        <mfp-input-currency
          type="text"
          view="agent"
          [name]="pendingAmountName"
          [formControlName]="pendingAmountName"
          [label]="pendingAmountLabel"
          [currencyOptions]="currencyOptions"
          [success]="isFieldValid(form, pendingAmountName)"
          [error]="isFieldInvalid(form, pendingAmountName)"
          [helper]="getFieldError(form, pendingAmountName) | translate"
          [readonly]="readonly"
          [required]="required"
        ></mfp-input-currency>
      </div>
      <div class="col-xs-24 col-sm-9 col-gutter-lr">
        <mfp-input-currency
          type="text"
          view="agent"
          [name]="monthlyFeeName"
          [formControlName]="monthlyFeeName"
          [label]="monthlyFeeLabel"
          [currencyOptions]="currencyOptions"
          [success]="isFieldValid(form, monthlyFeeName)"
          [error]="isFieldInvalid(form, monthlyFeeName)"
          [helper]="getFieldError(form, monthlyFeeName) | translate"
          [readonly]="readonly"
          [required]="required"
        ></mfp-input-currency>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-24 col-sm-6 col-gutter-lr">
        <mfp-input
          type="number"
          view="agent"
          [name]="remainingYearsName"
          [formControlName]="remainingYearsName"
          [label]="remainingYearsLabel"
          [placeholder]="remainingYearsPlaceholder"
          [success]="isFieldValid(form, remainingYearsName)"
          [error]="isFieldInvalid(form, remainingYearsName)"
          [helper]="getFieldError(form, remainingYearsName)"
          [readonly]="readonly"
          [required]="required"
        ></mfp-input>
      </div>
      <!-- This div is used to apply horizontal paddding since there is only one element on this row -->
      <div></div>
    </div>
  </div>
</div>
